export class AppConsts {
    static remoteServiceBaseUrl: string;
    
    static appBaseUrl: string;
}